import * as ActionTypes from "../actions/actionTypes";
import initialState from "./initialState";

export default function dashboardReducer(
  state = initialState.dashboard,
  action
) {
  switch (action.type) {
   case ActionTypes.GET_CUSTOMER_ZONE_BAR_DATA + ActionTypes.FULFILLED: {
      const data = action.payload?.data || {};
      return {
        ...state,
        customerZoneBarData: {
          items: data.items || [],
          totalCount: data.totalCount || 0
        }
      };
    }
    case ActionTypes.RESET_CUSTOMER_ZONE_BAR_DATA:
      return {
        ...state,
        customerZoneBarData: { items: [], totalCount: 0, loading: true }
      };

    case ActionTypes.GET_CUSTOMER_ZONE_POINTS_GRAPH + ActionTypes.FULFILLED:
      return {
        ...state,
        customerZonePointsGraph: {
          items: action.payload.data.zoneChartsList || [],
          totalCount: action.payload.data.totalCount || 0,
          loading: false
        }
      };

    case ActionTypes.GET_CUSTOMER_ZONE_CHANGES + ActionTypes.FULFILLED:
      return {
        ...state,
        customerZoneChanges: {
          items: action.payload.data.items || [],
          loading: false
        }
      };

    case ActionTypes.GET_CUSTOMER_ZONE_Model_CHANGE + ActionTypes.FULFILLED:
      return {
        ...state,
        customerZoneModelChange: {
          items: action.payload.data.items || [],
          loading: false
        }
      };

    case ActionTypes.GET_CUSTOMER_DASHBOARD_DATA + ActionTypes.FULFILLED:
    return {
      ...state,
      loadingCustomerDashboard: false,
      customerDashboardData: action.payload.data
    };

    case ActionTypes.GET_CUSTOMER_ZONE_DATA + ActionTypes.FULFILLED:
    return {
      ...state,
      customerZoneData: action.payload.data
    };

    default:
      return state;
  }
}
